import { useEffect, useState } from 'react'
import SearchableSelect from 'react-select'
import { toast } from 'react-toastify'
import BackButton from '../../../components/BackButton'
import OrderSuccess from '../../../components/Cart/OrderSuccess'
import LoadingBackground from '../../../components/LoadingBackground'
import { useCart } from '../../../context/CartContext'
import { useTitle } from '../../../hooks/useTitle'
import api from '../../../services/api'
import { customStylesForSearchableSelect } from '../../../util/searchableSelectStyle'
import * as S from './styles'
import CustomGroups from '../../../components/CustomGroups'
import { saveCustomFieldValue } from '../../../util/saveCustomFieldValue'
import verifyRequiredCustomFields from '../../../util/verifyRequiredCustomFields'
import chatbotApi from '../../../services/chatbotApi'

const CatalogCartPayment = () => {
  const { chatbotCart, updateMethodPayment, clearCart } = useCart()
  const [customFieldsFirstStep, setCustomFieldsFirstStep] = useState([])
  const [customFieldsLastStep, setCustomFieldsLastStep] = useState([])
  const [customFieldsToSave, setCustomFieldsToSave] = useState([])
  const [isSuccess, setIsSuccess] = useState(false)
  const [notes, setNotes] = useState('')
  const [paymentMethodId, setPaymentMethodId] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState([])
  const [selectedPayMethod, setSelectedPayMethod] = useState('')
  const [deadlines, setDeadlines] = useState([])
  const customer = JSON.parse(sessionStorage.getItem('customerChatbot'))
  const chatbotUser = JSON.parse(sessionStorage.getItem('@chatbotUser'))

  const handleSelectChange = (selectedOption) => {
    setPaymentMethodId(selectedOption.value);
    updateMethodPayment(selectedOption, true);
    setSelectedPayMethod(selectedOption);
    sessionStorage.setItem('selectedPayMethodChatbot', JSON.stringify(selectedOption));
  }

  const handleNotesChange = (e) => {
    setNotes(e.target.value);
    sessionStorage.setItem('invoiceNoteChatbot', JSON.stringify(e.target.value));
  }

  const getPaymentMethod = async () => {
    const response = await chatbotApi.get('/api/v2/PaymentMethod?OnlyB2B=true')
    let data = response.data.response.data;

    if (customer.invoiceLockPaymentMethodEcommerce && customer.preferredPaymentId > 0) {
      // pega só o método preferencial
      var preferredPayment = data?.find(paymentMethod => paymentMethod.id === customer.preferredPaymentId);

      if (customer.invoiceLockPaymentMethodAllowByInstallmentNumbers) {
        var preferredInstallments = preferredPayment.installmentsNumber != null ? preferredPayment.installmentsNumber : 0;

        if (preferredInstallments == 0) {
          var preferredPayment = data?.filter(paymentMethod => paymentMethod.installmentsNumber == 0);
        } else {
          var preferredPayment = data.filter(paymentMethod => paymentMethod.installmentsNumber <= preferredInstallments && paymentMethod.installmentsNumber > 0);
        }
      } else {
        preferredPayment = preferredPayment ? [preferredPayment] : preferredPayment;
      }

      if (preferredPayment) {
        data = preferredPayment;
      }
    }
    setPaymentMethod(data)
  }

  const validPaymentMethods = paymentMethod.filter((pay) => {
    if (pay.deadlineId && pay.deadlineId > 0) {
      const hasValidDeadline = deadlines.some(deadline => deadline.id === pay.deadlineId);
      if (!hasValidDeadline) {
        return false;
      }
    }

    if (!pay.status)
      return false;

    const hasValidMinimumPrice = !!pay.minimumPrice && pay.minimumPrice > 0;
    const hasValidMaximumPrice = !!pay.maximumPrice && pay.maximumPrice > 0;

    if (hasValidMinimumPrice || hasValidMaximumPrice) {
      if (hasValidMinimumPrice && hasValidMaximumPrice) {
        // Se tiver preço mínimo E preço máximo, verifica se o valor do pedido está entre os dois
        const isValid = chatbotCart?.totalValue >= pay.minimumPrice && chatbotCart?.totalValue <= pay.maximumPrice;
        return isValid;
      } else if (hasValidMinimumPrice && !hasValidMaximumPrice) {
        // Se tiver somente preço mínimo, verifica se o valor do pedido está acima do mínimo
        const isValid = chatbotCart?.totalValue >= pay.minimumPrice;
        return isValid;
      } else if (!hasValidMinimumPrice && hasValidMaximumPrice) {
        // Se tiver somente preço máximo, verifica se o valor do pedido está abaixo do máximo
        const isValid = chatbotCart?.totalValue <= pay.maximumPrice;
        return isValid;
      }
    } else {
        return true;
    }
  })

  const paymentMethodOptions = validPaymentMethods.map(payMethod => ({
    value: payMethod.id,
    label: payMethod.description,
    deadline: payMethod.deadlineId
  }))

  const CustomToastWithLink = () => (
    <span>Antes de fechar o pedido, é necessário cadastrar um endereço.</span>
  )

  const CustomFinancialToastWithLink = () => (
    <span>Você possui contas em atraso. Entre em contato com o financeiro.</span>
  )

  const mountWhatsAppUrl = (successRedirect, isMobile) => {
    const phoneNumber = customer.customerPhoneNumber;
    const message = successRedirect ? encodeURIComponent('Pedido finalizado') : '';
    const whatsappUrl = isMobile 
      ? `whatsapp://send?phone=${phoneNumber}&text=${message}`
      : `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${message}&type=phone_number&app_absent=0`
    return whatsappUrl;
  }

  const sendToBotmaker = async () => {
    const response = await chatbotApi.get(`api/v2/Chatbot/InvoiceDone?phoneNumber=${customer.customerPhoneNumber} `);
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const success = response.data.code === 200 && response.data.success;
    setTimeout(() => {
      if (isMobile) {
        // Mobile: abre na mesma janela
        const nativeUrl = mountWhatsAppUrl(success, true);
        const fallbackWebUrl = mountWhatsAppUrl(success, false);
        // Primeiro tenta abrir o app nativo
        window.location.href = nativeUrl;
        // Depois de 500ms, verifica se precisa do fallback
        setTimeout(() => {
          if (!document.hidden) {
            window.location.href = fallbackWebUrl;
          };
        }, 1200);
      } else {
        // Desktop: abre nova aba
        const url = mountWhatsAppUrl(success, false);
        window.open(url, '_blank', 'noopener,noreferrer');
      };
    }, 1000);
  }

  const newOrder = async () => {
    const responseAdr = await chatbotApi.get(`api/v2/Client/${customer.clientId}/Address`)
    const addressResponse = responseAdr.data.response.data

    if (chatbotCart?.items.length === 0) {
      toast.warning('Para efetuar o pedido, adicione produtos ao carrinho.', {
        position: 'top-right',
      })
      setButtonDisabled(false)
      return false
    }

    if (addressResponse.length === 0) {
      toast.error(CustomToastWithLink, {
        autoClose: false,
        position: 'top-right',
      })
      setButtonDisabled(false)
      return false
    }

    if (customFieldsToSave?.length > 0) {
      const hasRequiredCustomFieldsWithoutValue = verifyRequiredCustomFields(customFieldsToSave)
      if (hasRequiredCustomFieldsWithoutValue) {
        toast.warning(`Preencha os campos obrigatórios que contêm *`, {
          position: 'top-right',
        });
        setButtonDisabled(false)
        return false
      }
    }

    setIsLoading(true)

    //Pega por padrão o prazo de pagto disponível para o usuário
    var deadlineIdActive = (() => {
      var activeDeadline = chatbotUser.deadline?.find(deadline => deadline.status === 1);
      if (activeDeadline != null && chatbotUser.preferredDeadlineId != 0) {
        activeDeadline = chatbotUser.deadline?.find(x => x.id === chatbotUser.preferredDeadlineId && x.status === 1);
      }
      return activeDeadline ? activeDeadline.id : '';
    })()

    //Se a forma de pagto tiver um prazo ativo pega da forma de pagto
    if (chatbotCart?.deadline?.typeStatus == "Ativo") {
      deadlineIdActive = chatbotCart.deadlineId
    }

    const addInvoiceObj = {
      Advance: chatbotCart.advance,
      DeadlineId: deadlineIdActive,
      DeliveryForecast: chatbotCart.deliveryForecast,
      Discount: chatbotCart.discount,
      Freight: chatbotCart.freight,
      Items: chatbotCart.items,
      Nature: 2,
      Notes: notes,
      PaymentMethodId: paymentMethodId,
      Price: chatbotCart.price,
      Tax: chatbotCart.tax,
      TotalValue: chatbotCart.totalValue,
      Value: chatbotCart.value,
      PoliticsDiscount: chatbotCart.politicsDiscount,
      PoliticsAddition: chatbotCart.politicsAddition,
      CreationSource: 2
    }

    try {
      const response = await chatbotApi.post('/Invoice', addInvoiceObj)
      const invoiceId = response?.data?.data.id
      const cartId = JSON.parse(sessionStorage.getItem('@cartId'))
     
      if (customFieldsToSave.length > 0) {
        saveCustomFieldValue(customFieldsToSave, invoiceId)
      }

      if (!!cartId) {
        const deleteCart = await chatbotApi.post(`/api/v2/Cart/${cartId}/close`, { invoiceId })
        sessionStorage.removeItem('@cartId');
      }

      if (response.data.success) {
        setIsSuccess(true)
        clearCart()
        sendToBotmaker()
        sessionStorage.removeItem('selectedPayMethodChatbot');
        sessionStorage.removeItem('invoiceNoteChatbot');
      }

      setIsLoading(false)
      setButtonDisabled(false)
      toast(response.data.successMessages[0], {
        type: 'success',
        position: 'top-right',
      })
    } catch (error) {
      setIsLoading(false)
      setButtonDisabled(false)
      const receivedErrorMsg = error?.response?.data?.errorMessages[0];
      const financialNotRegular = receivedErrorMsg?.includes('pendência financeira');
      const errorMsg = financialNotRegular ? CustomFinancialToastWithLink() : receivedErrorMsg;
      toast(errorMsg ? errorMsg : 'Algo deu errado. Tente novamente mais tarde.', {
        type: 'error',
        autoClose: 10000,
        position: 'top-right',
      })
    }
  }

  useEffect(() => {
    if (chatbotUser) {
      setPaymentMethodId(chatbotUser.paymentMethod[0].id)
    }

    const getDeadlines = async () => {
      const response = await chatbotApi.get('/Deadline')
      setDeadlines(response.data)
    }

    if (!deadlines.length) {
      getDeadlines()
    }

    getPaymentMethod()

    if (chatbotCart?.items.length === 0) {
      setSelectedPayMethod('');
      sessionStorage.removeItem('selectedPayMethodChatbot');
    }
  }, [])

  useEffect(() => {
    const storedPayMethod = JSON.parse(sessionStorage.getItem('selectedPayMethodChatbot'))
    if (!!storedPayMethod) {
      if (storedPayMethod.deadline) {
        const hasValidDeadline = deadlines?.some(deadline => deadline.id === storedPayMethod.deadline && deadline.status === 1);
        if (!hasValidDeadline) {
          sessionStorage.removeItem('selectedPayMethodChatbot');
          return;
        } else {
          setSelectedPayMethod(storedPayMethod)
          setPaymentMethodId(storedPayMethod.value)
        }
      }
    }

    const storedInvoiceNote = JSON.parse(sessionStorage.getItem('invoiceNoteChatbot'))
    if (!!storedInvoiceNote) {
      setNotes(storedInvoiceNote)
    }
  }, [deadlines])

  useEffect(() => {
    setCustomFieldsToSave([...customFieldsFirstStep, ...customFieldsLastStep])
  }, [customFieldsFirstStep, customFieldsLastStep])

  useTitle(!isSuccess ? 'Fechamento do pedido' : 'Pedido realizado com sucesso')

  return (
    <>
      {isLoading && (
        <LoadingBackground />
      )}
      {(!isSuccess && chatbotCart) && (
        <S.CartPayment>
          <S.CartPaymentWrapper>
            <S.CartPaymentTop>
              <BackButton to='/chatbot-catalog/cart' />
              <S.CartPaymentTitle>Fechamento do pedido</S.CartPaymentTitle>
            </S.CartPaymentTop>
            <S.CartPaymentBoxContainer>
              <S.CartPaymentBox>
                <S.CartPaymentBold>Selecione uma forma de pagamento:</S.CartPaymentBold>
                {chatbotUser && customer && (
                  <S.SelectPayment>
                    <SearchableSelect
                      name='select-product'
                      value={selectedPayMethod}
                      placeholder="Selecione..."
                      onChange={handleSelectChange}
                      styles={customStylesForSearchableSelect}
                      options={paymentMethodOptions}
                      noOptionsMessage={() => 'Sem resultados.'}
                    />
                  </S.SelectPayment>
                )}
              </S.CartPaymentBox>
              <S.CartPaymentBox>
                <S.CartPaymentOrderPrices
                  value={chatbotCart.value}
                  tax={chatbotCart.tax}
                  freight={chatbotCart.freight}
                  discount={chatbotCart.politicsDiscount}
                  totalValue={chatbotCart.totalValue}
                  addition={chatbotCart.politicsAddition}
                />
              </S.CartPaymentBox>
              <S.CartPaymentBox>
                <S.CartPaymentDeliveryContainer>
                  <S.CartPaymentDeliveryItem>
                    <S.CartPaymentDeliveryLabel>Prazo de entrega</S.CartPaymentDeliveryLabel>
                    <S.CartPaymentDeliveryValue>{chatbotCart.deadline.description}</S.CartPaymentDeliveryValue>
                  </S.CartPaymentDeliveryItem>
                  {chatbotCart.deadline.type !== 3 &&
                  <S.CartPaymentDeliveryItem>
                    <S.CartPaymentDeliveryLabel>Previsão de entrega</S.CartPaymentDeliveryLabel>
                    <S.CartPaymentDeliveryValue>{chatbotCart.deliveryForecast}</S.CartPaymentDeliveryValue>
                  </S.CartPaymentDeliveryItem>}
                </S.CartPaymentDeliveryContainer>
              </S.CartPaymentBox>
              <S.CartPaymentBox>
                <CustomGroups entity={3} setCustomFieldsToSave={setCustomFieldsFirstStep} isChatbotCatalog/>
                <CustomGroups entity={4} setCustomFieldsToSave={setCustomFieldsLastStep} isChatbotCatalog/>
                <S.CartPaymentField>
                  <S.CartPaymentLabel>Gostaria de adicionar algum comentário?</S.CartPaymentLabel>
                  <S.CartPaymentTextarea value={notes} onChange={handleNotesChange}/>
                </S.CartPaymentField>
              </S.CartPaymentBox>
            </S.CartPaymentBoxContainer>
            {customer?.b2BMessagesCart && customer?.b2BMessagesCart != "<p><br></p><p></p>" && (
              <S.CartPaymentDisclaimer>
                <strong>Atenção:</strong>
                <S.CartMessage dangerouslySetInnerHTML={{ __html: customer?.b2BMessagesCart }} />
              </S.CartPaymentDisclaimer>
            )}
            <S.CartPaymentButton disabled={buttonDisabled} onClick={()=>{
              setButtonDisabled(true);
              newOrder();
            }}>
              Finalizar meu pedido agora
            </S.CartPaymentButton>
          </S.CartPaymentWrapper>
        </S.CartPayment>
      )}
      {isSuccess && (
        <OrderSuccess isChatbotCatalog />
      )}
    </>
  )
}

export default CatalogCartPayment;